import luxPopup from "../lux-popup.js";

const favorites = {
    toggle: function (element, productId) {
        const selectedListId = element.getAttribute("value");
        const selectedProductListId = element.getAttribute("id");

        const $luxFavoriteList = $(
            `.lux-favorite-list[data-id='${selectedProductListId}']`,
        );

        if ($luxFavoriteList.length) {
            $luxFavoriteList.toggleClass("favorite");
            const isFavorite = $luxFavoriteList.hasClass("favorite");
            $luxFavoriteList.find("input").prop("checked", isFavorite);
        }

        const $thisFavoriteList = $(
            `.favorite-list[data-id='${selectedProductListId}']`,
        );

        if ($thisFavoriteList.length) {
            $thisFavoriteList.toggleClass("favorite");
            const isFavorite = $thisFavoriteList.hasClass("favorite");
            $thisFavoriteList.find("input").prop("checked", isFavorite);
        }

        this.toggleBadgeHeart(productId);

        fetch("/favorite/toggle/" + selectedListId, {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-Token": window.CSRF_TOKEN,
            },
            method: "POST",
            body: JSON.stringify({
                productId: productId,
            }),
        });
    },

    openFavorites: function (e) {
        var $this = $(e);
        var listsContainer = $this.siblings(".favorite-lists-container");

        listsContainer.slideToggle({
            start: function () {
                $(this).css({
                    display: "flex",
                });
            },
        });

        $this.toggleClass("open");
    },

    initFavoritesSelector: function (id) {
        var swiperId = id.id;
        var initialized = false;

        if (initialized == false) {
            window.initializeSwiperScrollVertical(swiperId);
            initialized = true;
        }
    },

    toggleBadgeHeart: function (productId) {
        const $favoriteSelect = $(
            `.lux-favorite-select[data-id='${productId}']`,
        );

        if ($favoriteSelect.length) {
            const $favoritesIcon = $favoriteSelect.find(".lux-favorites-icon");
            const $favoriteSwiperWrapper = $favoriteSelect.siblings(
                ".lux-favorite-select-swiper-wrapper",
            );

            if (
                $favoriteSwiperWrapper.find(".lux-favorite-list.favorite")
                    .length
            ) {
                $favoritesIcon.addClass("active").removeClass("not-active");
            } else {
                $favoritesIcon.addClass("not-active").removeClass("active");
            }
        }

        const $favoriteBadgeWrapper = $(
            `.lux-badge-wrapper.favorites[data-id='${productId}']`,
        );

        if ($favoriteBadgeWrapper.length) {
            const $favoriteBadge = $favoriteBadgeWrapper.find(".lux-badge");
            const $listsContainer = $favoriteBadgeWrapper.siblings(
                ".favorite-lists-container",
            );

            if ($listsContainer.find(".favorite-list.favorite").length) {
                $favoriteBadgeWrapper.addClass("active");
                $favoriteBadge
                    .addClass("heart-full")
                    .removeClass("heart-empty");
            } else {
                $favoriteBadgeWrapper.removeClass("active");
                $favoriteBadge
                    .removeClass("heart-full")
                    .addClass("heart-empty");
            }
        }
    },
};

window.favorites = favorites;

const addCartProductFavorites = document.querySelectorAll(
    ".add-cart-product-favorites",
);

addCartProductFavorites.forEach(function (el) {
    el.addEventListener("click", function () {
        const cartProduct = el.closest(".lux-cart-product");

        const defaultList = cartProduct.querySelector(
            ".lux-favorite-list input[data-is-default='1']",
        );

        const cartProductFavoritesToast = document.querySelector(
            ".toast-cart-product-added-favorites",
        );

        if (defaultList instanceof HTMLInputElement) {
            if (defaultList.checked) {
                // Remove and re-add to move to the top of favorites
                defaultList.click();

                setTimeout(() => {
                    defaultList.click();
                }, 50);
            } else {
                defaultList.click();
            }

            luxPopup.toastShow(cartProductFavoritesToast);
        }
    });
});
